import { render, staticRenderFns } from "./ProductWarehouseStocks.vue?vue&type=template&id=29bc0469&scoped=true&"
import script from "./ProductWarehouseStocks.vue?vue&type=script&lang=js&"
export * from "./ProductWarehouseStocks.vue?vue&type=script&lang=js&"
import style0 from "./ProductWarehouseStocks.vue?vue&type=style&index=0&id=29bc0469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc0469",
  null
  
)

export default component.exports